import type { ReactElement } from 'react';
import { memo } from 'react';

import { MultipleIcon } from '@bestseller-bit/frontend-community.theme.buying-theme';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

interface OpenInsertStylesDialogButtonProps {
    onClick: () => void;
}

/** Opens the dialog used to insert multiple styles manually. */
const OpenInsertStylesDialogButton = memo(
    ({
        onClick: handleClick,
    }: OpenInsertStylesDialogButtonProps): ReactElement => (
        <Tooltip
            title="Click here to insert multiple styles"
            placement="top"
        >
            <IconButton
                size="small"
                aria-label="Insert multiple styles"
                onClick={(event): void => {
                    // The dropdown is a Popover with its own focus trap and no close API here, so
                    // dismiss it with Escape. Left open it keeps focus and the dialog cannot be
                    // typed in. Escape must go to the Popover root — the Autocomplete in between
                    // swallows it.
                    event.currentTarget
                        .closest('[role="presentation"]')
                        ?.dispatchEvent(
                            new KeyboardEvent('keydown', {
                                key: 'Escape',
                                bubbles: true,
                            })
                        );

                    handleClick();
                }}
            >
                <MultipleIcon />
            </IconButton>
        </Tooltip>
    )
);

OpenInsertStylesDialogButton.displayName = 'OpenInsertStylesDialogButton';

export { OpenInsertStylesDialogButton };
